import clsx from "clsx";
import React from "react";
import { ISharedTemplate } from "../utils/Types";
import { NavLink, useParams } from "react-router-dom";
import { truncate } from "lodash";
import { FileText, User } from "@phosphor-icons/react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface TemplateProps {
  template: ISharedTemplate;
  icon: React.ReactNode;
  category?: string;
}

const SharedTemplate: React.FC<TemplateProps> = ({
  template,
  icon,
  category,
}) => {
  const { templateId = "" } = useParams<{
    templateId: string;
  }>();

  const itemClass = clsx(
    // "bg-gray-25/10 dark:bg-gray-900 shadow-md rounded-lg border-[0.5px] border-gray-25 dark:border-gray-500 hover:bg-gray-25/50 dark:hover:bg-gray-900/50 ",
    "dark:bg-gray-900 shadow-md rounded-lg border-[0.5px] border-gray-25 dark:border-gray-500 hover:bg-gray-25/50 dark:hover:bg-gray-900/50 ",
    templateId ? "bg-gray-25/10  " : "bg-white ",
    {
      "bg-sky-25/50 hover:border-sky-100 dark:bg-sky-600/50 border-sky-200 dark:border-sky-200 hover:bg-sky-25 dark:hover:bg-sky-600/80":
        template?.template?.public_access_key == templateId,
    }
  );

  const content = (
    <div className={clsx("flex flex-col p-3 max-h-[112px]", {})}>
      <div className="flex items-center justify-between">
        <div
          className={
            "flex items-center text-sm font-medium mr-2 truncate text-sky-200 dark:text-sky-50 " +
            (template?.template?.public_access_key == templateId
              ? "text-sky-200 dark:text-white"
              : "")
          }
        >
          <Tooltip>
            <TooltipContent side="top" className="bg-gray-600 text-white">
              <p>{category}</p>
            </TooltipContent>
            <TooltipTrigger asChild>
              <div className="w-fit mr-2">{icon || <FileText size={20} />}</div>
            </TooltipTrigger>
          </Tooltip>
          {template?.template?.title
            ? truncate(template?.template?.title, { length: 30 })
            : "New Template"}
        </div>
      </div>
      {template?.template?.description && (
        <span
          className={
            "text-sm font-medium mr-2 mt-1 truncate text-gray-500 dark:text-gray-300 " +
            (template?.template?.public_access_key == templateId
              ? " dark:text-white"
              : " dark:text-gray-50")
          }
        >
          {template?.template?.description}
        </span>
      )}
      <div
        className={clsx("flex", {
          "mt-2": !template?.template?.description,
        })}
      >
        <div className="flex items-center">
          <div
            className={
              "flex items-center text-gray-400 mt-2 text-xs" +
              (template?.template?.public_access_key == templateId
                ? "text-sky-200 dark:text-white"
                : " dark:text-gray-50")
            }
          >
            <User
              className={
                "h-4 w-4 mr-1 text-gray-400 " +
                (template?.template?.public_access_key == templateId
                  ? "text-sky-200 dark:text-white"
                  : " dark:text-gray-50")
              }
            />

            <span className="text-xs">
              {`${template?.shared_by?.first_name} ${template?.shared_by?.last_name}`}
            </span>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <li className={itemClass}>
      {
        <NavLink
          to={`/dashboard/shared-templates/${template?.template?.public_access_key}?side=true`}
          className={({ isActive }) =>
            clsx("relative focus:outline-slate-500", {
              "text-slate-400": isActive,
              "block text-slate-800": !isActive,
            })
          }
        >
          {content}
        </NavLink>
      }
    </li>
  );
};

export default SharedTemplate;
